import { observable } from "mobx";
import Enum from "./enum";
import LanguageCode from "./languageCode";
import ExemptionReason from "./exemptionReason";
import Optionable from "../utils/optionable";

@Optionable((exemptionReason: ExemptionReasonResponse) => ({
  id: exemptionReason.exemptionReason,
  label: exemptionReason.description,
}))
export default class ExemptionReasonResponse extends Enum {
  id!: string;

  @observable
  exemptionReason!: ExemptionReason;

  @observable
  languageCode!: LanguageCode;

  @observable
  description!: string;
}
